var $2867ee6173245507$exports = {};
$2867ee6173245507$exports = {
  "buttonLabel": "Zobrazi\u0165 n\xE1vrhy",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " mo\u017Enos\u0165");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " mo\u017Enosti/-\xED");
      }
    }), " k dispoz\xEDcii.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Zadan\xE1 skupina ".concat(args.groupTitle, ", s ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " mo\u017Enos\u0165ou");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " mo\u017Enos\u0165ami");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", vybrat\xE9",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "N\xE1vrhy",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", vybrat\xE9");
  }
};
export { $2867ee6173245507$exports as default };